__turbopack_context__.v({
  "containerCarousel": "styles-module-scss-module__YusnUq__containerCarousel",
  "heading": "styles-module-scss-module__YusnUq__heading",
  "hr": "styles-module-scss-module__YusnUq__hr",
  "mainContainer": "styles-module-scss-module__YusnUq__mainContainer",
  "root": "styles-module-scss-module__YusnUq__root",
  "subTitle": "styles-module-scss-module__YusnUq__subTitle",
  "title": "styles-module-scss-module__YusnUq__title",
  "vector2": "styles-module-scss-module__YusnUq__vector2",
});
